import React from "react"

import { Skeleton } from "../Skeleton"

const AreaGraphSilhouette = () => {
  return (
    <Skeleton className="w-full max-h-[358px] p-5">
      <div className="flex justify-between items-end">
        <div className="h-5 rounded-full bg-neutral-300 dark:bg-neutral-700 max-w-[160px] mb-6 grow"></div>
        <div className="h-4 rounded-full bg-neutral-300 dark:bg-neutral-700 max-w-[250px] mb-6 grow"></div>
      </div>
      <div className="flex flex-row justify-between w-full">
        <div className="grow mr-6" style={{ maxWidth: "30px" }}>
          {[...Array(7)].map((_, index) => (
            <div
              key={index}
              className="h-3 rounded-full bg-neutral-300 dark:bg-neutral-700 max-w-[30px] mb-6"
            ></div>
          ))}
        </div>

        <div className="grow ">
          <div className="flex justify-between items-end w-full align-bottom h-[230px]">
            {" "}
            {/* Fixed height for the container */}
            <svg
              viewBox="0 0 420 100"
              xmlns="http://www.w3.org/2000/svg"
              className="grow h-full w-full"
            >
              {" "}
              {/* SVG fills container */}
              <path
                d="M0,80 L40,50 L80,30 L120,20 L160,35 L200,40 L200,100 L0,100 Z"
                fill="#D1D5DB"
              />
              <path
                d="M210,40 L230,50 L250,35 L270,40 L290,36 L310,40 L330,45 L350,30 L370,40 L420,20 L420,200 L210,100 Z"
                fill="#D1D5DB"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="flex flex-row justify-around h-full">
        {[...Array(7)].map((_, index) => (
          <React.Fragment key={`block-row-${index}`}>
            <div
              key={index}
              className="grow h-3 rounded-full bg-neutral-300 dark:bg-neutral-700 max-w-[30px] mb-6"
            ></div>
          </React.Fragment>
        ))}
      </div>
    </Skeleton>
  )
}

export default AreaGraphSilhouette
